export const intercomDimensions = {
  width: 60,
  height: 60,
  vPadding: 20,
  hPadding: 20
};
